// extracted by mini-css-extract-plugin
module.exports = {"title":"DetailsItem_title__2KK2V","value":"DetailsItem_value__35Cyu"};